import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { useTheme } from "@mui/material/styles"

import Column from "../../../common/components/Column"
import { recruitProfileNestedPanelSx } from "./recruitProfileSectionStyles"

/**
 * Inner panel matching office-address / additional-office blocks.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.title] Optional uppercase-style group label
 */
export default function RecruitProfileNestedPanel({ children, title }) {
  const theme = useTheme()
  return (
    <Box sx={recruitProfileNestedPanelSx(theme)}>
      {title ? (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontWeight: 700,
            letterSpacing: 0.4,
            display: "block",
            mb: 1.5,
          }}
        >
          {title.toUpperCase()}
        </Typography>
      ) : null}
      <Column sx={{ gap: 2, alignItems: "stretch" }}>{children}</Column>
    </Box>
  )
}
